import { PropsWithChildren } from "react";
import styles from "./carousel.module.css";

const Carousel: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="overflow-hidden pt-16 pb-4">
      <div className={styles.track}>{children}</div>
    </div>
  );
};

export default Carousel;
